export const utils = [
  {
    key: 0,
    text: "Presencial",
    value: "Presencial",
  },
  {
    key: 1,
    text: "Híbrido",
    value: "Híbrido",
  },
  {
    key: 2,
    text: "Remoto",
    value: "Remoto",
  },
];

export const contractTypeUtils = [
  {
    key: 1,
    text: "Efetivo",
    value: "Efetivo",
  },
  {
    key: 2,
    text: "Temporário",
    value: "Temporario",
  },
  {
    key: 3,
    text: "Estágio",
    value: "Estagio",
  },
];

export const workLocation = [
  {
    key: 0,
    text: "Juiz de Fora",
    value: "Juiz de Fora",
  },
  {
    key: 1,
    text: "Remoto",
    value: "Remoto",
  },
];
